import { Tile, LetterState } from '../types/game';

// Kelimeler listesi - JSON dosyasından yüklenecek
let TURKISH_WORDS: string[] = [];

// JSON dosyasından kelimeleri yükle
export const loadWords = async (): Promise<string[]> => {
    if (TURKISH_WORDS.length > 0) {
        return TURKISH_WORDS;
    }

    try {
        const response = await fetch('/kelimeler.json');
        const words = await response.json();

        // Sadece 5 harfli kelimeleri filtrele ve büyük harfe çevir
        TURKISH_WORDS = words
            .filter((word: string) => word.length === 5)
            .map((word: string) => word.toUpperCase())
            .filter((word: string) => /^[A-ZÇĞIİÖŞÜ]+$/.test(word));

        console.log(`${TURKISH_WORDS.length} kelime yüklendi`);
        return TURKISH_WORDS;
    } catch (error) {
        console.error('Kelimeler yüklenirken hata:', error);
        // Fallback olarak eski listeyi kullan
        TURKISH_WORDS = [
            'AKICI', 'BALIK', 'CEMRE', 'DENIZ', 'ELMAS', 'FENER', 'GÜLME', 'HIZLI',
            'İNCE', 'JETON', 'KALEM', 'LİMON', 'MAKAS', 'NARIN', 'OKUL', 'PAPATYA',
            'RÜZGAR', 'SABUN', 'TARAK', 'UÇAK', 'VİDEO', 'YAPRAK', 'ZEYTİN'
        ];
        return TURKISH_WORDS;
    }
};

export const generateRandomWord = async (): Promise<string> => {
    const words = await loadWords();
    return words[Math.floor(Math.random() * words.length)];
};

export const generateRoomCode = (): string => {
    return Math.random().toString(36).substring(2, 8).toUpperCase();
};

export const validateGuess = (guess: string, targetWord: string): Tile[] => {
    const tiles: Tile[] = [];
    const targetLetters = targetWord.split('');
    const guessLetters = guess.split('');

    // Önce doğru pozisyonları bul
    const correctPositions = new Set<number>();
    const remainingTargetLetters = [...targetLetters];
    const remainingGuessLetters = [...guessLetters];

    // Doğru pozisyonları işaretle
    for (let i = 0; i < guessLetters.length; i++) {
        if (guessLetters[i] === targetLetters[i]) {
            correctPositions.add(i);
            remainingTargetLetters[i] = '';
            remainingGuessLetters[i] = '';
        }
    }

    // Kalan harfleri kontrol et
    for (let i = 0; i < guessLetters.length; i++) {
        if (correctPositions.has(i)) {
            tiles.push({ letter: guessLetters[i], state: 'correct' });
        } else if (remainingGuessLetters[i] !== '') {
            const letterIndex = remainingTargetLetters.indexOf(remainingGuessLetters[i]);
            if (letterIndex !== -1) {
                tiles.push({ letter: remainingGuessLetters[i], state: 'present' });
                remainingTargetLetters[letterIndex] = '';
            } else {
                tiles.push({ letter: remainingGuessLetters[i], state: 'absent' });
            }
        } else {
            tiles.push({ letter: '', state: 'empty' });
        }
    }

    return tiles;
};

export const isWordValid = async (word: string): Promise<boolean> => {
    const words = await loadWords();
    return word.length === 5 && /^[A-ZÇĞIİÖŞÜ]+$/.test(word) && words.includes(word.toUpperCase());
};

export const getKeyboardState = (guesses: Tile[][]): Record<string, LetterState> => {
    const keyboardState: Record<string, LetterState> = {};

    guesses.forEach(guess => {
        guess.forEach(tile => {
            if (tile.letter && tile.state !== 'empty') {
                const currentState = keyboardState[tile.letter];
                if (!currentState || tile.state === 'correct' ||
                    (tile.state === 'present' && currentState === 'absent')) {
                    keyboardState[tile.letter] = tile.state;
                }
            }
        });
    });

    return keyboardState;
};
